var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selectPlugin != null)?_c('iframe',{ref:"iframeSystemSettings",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"show-plugin","frameBorder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }